/* Atipiná — Cards de produto (incluindo PDP related + home best sellers):
   1) Reordena preço: riscado primeiro, atual bold, 4x por último
   2) Smart badge: APENAS ESGOTADO > -XX%
   3) Badges informativas (BEST SELLER, LANÇAMENTO, ÚLTIMAS UNIDADES) ficam só na PDP
   2026-05-22 v7 */

(function(){
  var INSTALLMENTS = 4;
  var CLASS_FLAG = 'atipina-4x';
  var ATTR_INST = 'data-atipina-inst';
  var ATTR_BADGE = 'data-atipina-badge';

  function parseBRL(text){
    if (!text) return 0;
    var clean = String(text).replace(/[^\d.,]/g, '');
    if (!clean) return 0;
    if (clean.indexOf(',') >= 0){
      clean = clean.replace(/\./g, '').replace(',', '.');
    }
    var num = parseFloat(clean);
    return isNaN(num) ? 0 : num;
  }

  function formatBRL(num){
    var s = num.toFixed(2).replace('.', ',');
    var parts = s.split(',');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return 'R$ ' + parts.join(',');
  }

  function getCardPriceContainer(card){
    var selectors = ['.pdp-related__card-price','.product-item__price','.product-item__price-container','.product__price','.card__price','.product-card__price','.grid-product__price','[data-product-price]','.price'];
    for (var i = 0; i < selectors.length; i++){
      var el = card.querySelector(selectors[i]);
      if (el) return el;
    }
    return null;
  }

  function reorderPrice(priceContainer){
    var innerPrice = priceContainer.querySelector('.price');
    if (innerPrice){
      var oldPrice = innerPrice.querySelector('.old-price, .product-item__price--compare, .product-price-compare');
      var newPrice = innerPrice.querySelector('.new-price, .price-item--sale, .product-item__price--sale');
      if (oldPrice && newPrice && innerPrice.firstElementChild !== oldPrice){
        innerPrice.insertBefore(oldPrice, innerPrice.firstChild);
      }
      return;
    }
    var strike = priceContainer.querySelector('s, del, .price__strike, .old-price');
    if (strike && strike.parentNode === priceContainer && priceContainer.firstElementChild !== strike){
      priceContainer.insertBefore(strike, priceContainer.firstChild);
    }
  }

  function getDisplayedPrice(priceContainer){
    var newPrice = priceContainer.querySelector('.new-price, .price-item--sale, .product-item__price--sale, strong, [data-product-price]:not(s):not(del)');
    if (newPrice){
      var val = parseBRL(newPrice.textContent || '');
      if (val > 0) return val;
    }
    return parseBRL((priceContainer.textContent || '').trim());
  }

  function shouldSkipCard(card){
    if (card.closest && card.closest('.pdp-look')) return true;
    return false;
  }

  function getImageWrap(card){
    return card.querySelector('.pdp-related__card-imgwrap, .product-item__image, .product-card__image, .product__image') || card;
  }

  function detectSoldOut(card){
    if (card.classList && card.classList.contains('product-item--soldout')) return true;
    if (card.querySelector('.sold-out, [data-product-sold-out]')) return true;
    var existingBadges = card.querySelectorAll('.badge-box, .preorder-box, .sale-box');
    for (var i = 0; i < existingBadges.length; i++){
      var t = (existingBadges[i].textContent || '').trim().toLowerCase();
      if (t === 'esgotado' || t === 'sold out') return true;
    }
    return false;
  }

  function determineSmartBadge(card){
    // APENAS as duas badges "comerciais" aparecem no card:
    // 1) ESGOTADO  2) -XX%
    // BEST SELLER / LANÇAMENTO / ÚLTIMAS UNIDADES vivem só na PDP.

    if (detectSoldOut(card)) return { text: 'ESGOTADO', cls: 'atipina-badge--soldout' };

    var newPriceEl = card.querySelector('.new-price, .product-item__price--sale, .price-item--sale, .pdp-related__card-price strong, [data-product-price]:not(s):not(del)');
    var oldPriceEl = card.querySelector('.old-price, .product-item__price--compare, .pdp-related__card-price s, s, del');
    if (newPriceEl && oldPriceEl){
      var newVal = parseBRL(newPriceEl.textContent);
      var oldVal = parseBRL(oldPriceEl.textContent);
      if (oldVal > newVal && oldVal > 0){
        var pct = Math.round((oldVal - newVal) / oldVal * 100);
        return { text: '-' + pct + '%', cls: 'atipina-badge--sale' };
      }
    }

    return null;
  }

  function applySmartBadge(card){
    if (card.getAttribute(ATTR_BADGE) === '1') return;

    var winning = determineSmartBadge(card);

    var existing = card.querySelectorAll('.badge-box, .preorder-box, .sale-box, .atipina-badge');
    for (var i = 0; i < existing.length; i++){ existing[i].remove(); }

    if (winning){
      var imageWrap = getImageWrap(card);
      var span = document.createElement('span');
      span.className = 'badge-box atipina-badge ' + winning.cls + ' text-left';
      span.textContent = winning.text;
      imageWrap.appendChild(span);
    }

    card.setAttribute(ATTR_BADGE, '1');
  }

  function injectInstallment(card){
    if (shouldSkipCard(card)) {
      card.setAttribute(ATTR_INST, '1');
      card.setAttribute(ATTR_BADGE, '1');
      return;
    }

    applySmartBadge(card);

    if (card.getAttribute(ATTR_INST) === '1') return;
    if (card.closest && card.closest('.pdp-related')){
      card.setAttribute(ATTR_INST, '1');
      return;
    }

    var priceContainer = getCardPriceContainer(card);
    if (!priceContainer) return;

    reorderPrice(priceContainer);

    var existing4x = priceContainer.querySelector('.' + CLASS_FLAG);
    if (existing4x) {
      if (priceContainer.lastElementChild !== existing4x){
        priceContainer.appendChild(existing4x);
      }
      card.setAttribute(ATTR_INST, '1');
      return;
    }

    var price = getDisplayedPrice(priceContainer);
    if (price <= 0) return;

    var installment = price / INSTALLMENTS;
    var span = document.createElement('span');
    span.className = CLASS_FLAG;
    span.textContent = INSTALLMENTS + 'x ' + formatBRL(installment);
    priceContainer.appendChild(span);
    card.setAttribute(ATTR_INST, '1');
  }

  function run(){
    var cardSelectors = ['.product-item','.product-card','.grid-product','[data-product-card]','.collection-product','product-item','.pdp-related__card'];
    var cards = document.querySelectorAll(cardSelectors.join(','));
    cards.forEach(injectInstallment);
  }

  function init(){
    run();
    setTimeout(run, 300);
    setTimeout(run, 1000);
    setTimeout(run, 2500);

    var debounceTimer = null;
    var observer = new MutationObserver(function(){
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(run, 150);
    });
    observer.observe(document.body, { childList: true, subtree: true });

    document.addEventListener('shopify:section:load', run);
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
